import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { faAdd, faInfo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Tab from '../../../../component/Tabs/Tab';
import ButtonOptionGroup from '../../component/ButtonOptions/ButtonOption';
import DataTablePageDynamic from '../../../../component/Table/DataTablePageDynamic';
import DataTableDynamic from '../../../../component/Table/DataTableDynamic';

const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};

const ReportVendorBalance = () => {
    const navigate = useNavigate();
    const [keys, setKeys] = useState([]);
    const [columns, setColumns] = useState([]);

    const [data, setData] = useState([]);
    
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_REPORT = "api/erpppsu/report/PiutangSupplier";

    const [filterFirstDate, setFilterFirstDate] = useState(getTodayDate());
    const [filterLastDate, setFilterLastDate] = useState(getTodayDate());

    // Fetch data from the API
    const fetchData = async (URL, config) => {
        try {
            const response = await axios.get(URL, config);
            return response.data; // Return only the data from the response
        } catch (err) {
            setError("Failed to fetch data. Please try again later.");
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(`${BASE_URL}${PATH_REPORT}?first_date=${filterFirstDate}&last_date=${filterLastDate}`).then((data) => {
            setData(data.data);
        });
    }, []);

    useEffect(() => {
        setKeys(data.length > 0 ? Object.keys(data[0]) : []);
    }, [data]);

    useEffect(() => {
        setColumns(keys.map(key => ({
            Header: key.charAt(0).toUpperCase() + key.slice(1),
            accessor: key
        })));
    }, [keys]);

    const handleFilter = () => {
        if (filterFirstDate && filterLastDate) {
            fetchData(`${BASE_URL}${PATH_REPORT}?first_date=${filterFirstDate}&last_date=${filterLastDate}`).then((data) => {
                setData(data.data);
            });
        }
    };

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div>
            <div className='flex items-center justify-between'>
                <h2 className="text-2xl font-bold mb-4">Daftar Penjualan</h2>

                <div className='flex items-center'>
                    {/* <ButtonOptionGroup
                        label={"Buat Penjualan Baru"}
                        options={options}
                        onChange={(value) => {
                            navigate(`/activity-erpppsu/sales/new/${value}`);
                        }}
                    /> */}
                </div>
            </div>

            <div className="container m-auto grid grid-cols-5 sm:grid-cols-2 xs:grid-cols-1 md:grid-cols-3 lg:grid-cols-5 my-3 gap-4">
                {/* First Date Input */}
                <div className="mx-1">
                    <label htmlFor="first_date" className="block mb-1 text-sm font-semibold">
                        Tanggal Awal
                    </label>
                    <input
                        id="first_date"
                        name="first_date"
                        type="date"
                        className="my-1 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                        value={filterFirstDate}
                        onChange={(e) => setFilterFirstDate(e.target.value)}
                    />
                </div>

                {/* Last Date Input */}
                <div className="mx-1">
                    <label htmlFor="last_date" className="block mb-1 text-sm font-semibold">
                        Tanggal Akhir
                    </label>
                    <input
                        id="last_date"
                        name="last_date"
                        type="date"
                        className="my-1 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                        value={filterLastDate}
                        onChange={(e) => setFilterLastDate(e.target.value)}
                    />
                </div>

                {/* Filter Button */}
                <div className="p-3 flex items-end">
                    <button
                        onClick={handleFilter}
                        type="button"
                        className="w-full bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring focus:ring-blue-200"
                    >
                        Filter
                    </button>
                </div>
            </div>


            {loading ? (
                <center><h1>Loading...</h1></center>
            ) : (
                <DataTableDynamic
                    data={data}
                    elementClass="p-1"
                    columns={columns}
                    moduleActions={[]}
                    enableCustom={false} />
            )}
        </div>
    )
}

export default ReportVendorBalance;
